import React from 'react';
import Footer from '../components/Footer';
import GamePage from '../components/GamePage';

import AGoodAlien_Img01 from '../images/agoodalien/mockup.png';


function AGoodAlien() {
  return (
    <>
      <GamePage
        name="A Good Alien"
        description="A Good Alien is a platform game. Your goal as the alien is to raid desert planets
        collecting resources like seeds and water to help brings life again to these planets."
        images={[AGoodAlien_Img01]}
        conclusion="Mostly developed using C# and Unity Game Engine this is an unreleased 
        personal project aka my first Multiplayer game."
      />
      <Footer />
    </>
  );
}

export default AGoodAlien;